module.exports = __webpack_public_path__ + "img/10.7b4f4498.jpg";